export default "__VITE_ASSET__uf8g$jae__"